import { ArrowRight } from 'lucide-react';
import { WAF_FREE_FEATURES, WAF_GUIDE_URL } from '@/components/promos/WafPromoBanner';
import { brand } from '@/config/brand';
import styles from './WafFreeAuthPanel.module.css';

/**
 * Branded left panel for the redesigned auth split (sign in / sign up).
 *
 * The red→orange mosaic gradient AND the 3D VNETWORK mark are one baked artwork
 * (`/assets/waf-free-panel.png`) — the design team's rendered hero. The headline,
 * benefit chips and CTA are real HTML overlaid on top (top-aligned) so the copy
 * stays crisp and localizable while the art bleeds to the panel's rounded edges.
 *
 * data-theme="light" pins the panel to the light palette: the artwork is a fixed
 * red hero, so text/chips must read as white-on-red in BOTH app themes (the form
 * pane beside it still flips with the theme toggle).
 */
export function WafFreeAuthPanel() {
  return (
    <div
      className={styles.panel}
      data-theme="light"
      // Public asset — set at runtime so the bundler doesn't try to resolve it as a module.
      style={{ backgroundImage: 'url(/assets/waf-free-panel.png)' }}
    >
      <div className={styles.content}>
        <h2 className={styles.headline}>Protect your website for free today</h2>
        <p className={styles.subtitle}>
          Activate WAF Free — {brand.shortName}'s Web Application Firewall.
        </p>

        <ul className={styles.chips}>
          {WAF_FREE_FEATURES.map((label) => (
            <li key={label} className={styles.chip}>
              {label}
            </li>
          ))}
        </ul>

        <a
          className={styles.cta}
          href={WAF_GUIDE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          See the 3-step setup
          <ArrowRight size={16} strokeWidth={2.5} />
        </a>
      </div>
    </div>
  );
}

export default WafFreeAuthPanel;
